import enTranslations from "./en/translations.json";
import skTranslations from "./sk/translations.json";

const resources = {
  en: enTranslations,
  sk: skTranslations,
};

export { resources };
